import '../main.less';
import React from 'react';
import ModalBox from '../../../../shared/modal';
import { Field, reduxForm } from 'redux-form';

import SelectField from '../../../../shared/form-elements/select/field';
import Checkbox from '../../../../shared/form-elements/checkbox';

const Form = props => {
	const { submitPayoutRequestEdit, editingRequest, changeEditFormFieldToDefault } = props;

	return (
		<div className="payout-request-form-wrap payouts-form-in-modal">
			<form
				className="ui-form payouts-form__main clearfix display-flex-column"
				onSubmit={props.handleSubmit(submitPayoutRequestEdit)}
			>
				<div className="ui-form__element">
					<Field
						name="country_id"
						placeholder={props.intl('Country id')}
						component={SelectField}
						searchable={true}
						multi={false}
						options={props.locationsLookupEditForm.bind(null, editingRequest)}
						onChange={changeEditFormFieldToDefault}
					/>
				</div>
				<div className="ui-form__element">
					<Field
						name="campaign_id"
						placeholder={props.intl('Campaign id')}
						component={SelectField}
						searchable={true}
						multi={false}
						options={props.campaignsLookupEditForm.bind(null, editingRequest)}
					/>
				</div>
				<div className="ui-form__element amount">
					<Field
						name="sid_type"
						placeholder={props.intl('Sid type')}
						component={SelectField}
						multi={false}
						showLabel={true}
						searchable={false}
						options={[1, 2, 3, 4, 5].map( item => `sid${item}`).map(item =>({ value: item, label: item }))}
					/>
				</div>

				<div className="ui-form__element amount">
					<Field
						name="sid"
						placeholder={props.intl('Sid')}
						component={SelectField}
						searchable={true}
						multi={false}
						options={props.sidLookupEditForm.bind(null, editingRequest)}
					/>
				</div>
				<div className="ui-form__element">
					<Field
						name="is_traffic_scaling"
						placeholder={props.intl('Is traffic scaling')}
						component={Checkbox}
					/>
				</div>
				<div className="display-flex margin-top-15">
					<button type="submit" className="ui-btn ui-btn-primary apply">
						{props.intl('Apply')}
					</button>
					<button
						className="ui-btn ui-btn-cancel cancel"
						onClick={e => {
							e.preventDefault();
							props.toggleEditForm();
						}}
					>
						{props.intl('Cancel')}
					</button>
				</div>
			</form>
		</div>
	);
};

const Main = props =>
	<ModalBox
		title={props.intl('Edit payout request')}
		body={Form(props)}
		isOpen={props.isRequestEditFormVisible}
		onClose={props.toggleEditForm}
		className="form-modal payout-request-modal payout-edit-modal"
	/>;

export default reduxForm({ form: 'editPayoutRequestForm', enableReinitialize: true })(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-requests/components/forms/edit-payout-request/main.js